import React, {useState, useEffect} from "react";
import {useFetch} from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";
import GeneratePDF from "./GeneratePDF";
import {IoPersonAdd} from "react-icons/io5";
import BeneficiaryModal from "../../configuration/components/BeneficiaryModal";
import ErrorModal from "../../reports/components/ErrorModal";
import {getDateRange} from "utils/utils"

const ExpenseModal = ({
                          showModal,
                          setModalState,
                          refreshData,
                          organizationData,
                          organizationId,
                          accountId,
                          availableAccounts,
                          existingFormData,
                          setExistingFormData,
                          addPreviousMonthRecord,
                          setExpenseConfirmModalState
                      }) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [natures, setNatures] = useState(null);
    const [beneficiaries, setBeneficiaries] = useState(null);
    const [showBeneficiaryModal, setShowBeneficiaryModal] = useState(false);
    const [currency, setCurrency] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = React.useState({
        organizationId: organizationId,
        accountId: accountId,
    });

    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");

    useEffect(() => {
        const { minDate, maxDate } = getDateRange(addPreviousMonthRecord);
        setMinDate(minDate);
        setMaxDate(maxDate);
    }, [addPreviousMonthRecord]);


    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const {id, value} = event.target;
        if (id === 'amount') {
            let amountUsdValue;
            if (currency === "JPY") {
                amountUsdValue = (value / formData.exchangeRate).toFixed(2);
            } else {
                amountUsdValue = (value * 1).toFixed(2);
            }
            updateFormData('amountUsdValue', amountUsdValue);
        }
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const updateFormData = (id, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    }

    const setErrorForField = (field) => {
        setFormErrorData({[field]: "error"});
    }

    const errors = {
        organizationId: "Please select Orgão",
        seqNumber: "Please enter valid N.Doc",
        paymentDate: "Please enter valid Data pagamento",
        description: "Please enter Descrição",
        beneficiaryId: "Please select Beneficiário/empresa",
        fundResource: "Please select Fonte de recursos",
        natureId: "Please select Nat de despesa",
        registrationDate: "Please enter valid Data de registro",
        dueDate: "Please enter valid Data de vencimento",
        amount: "Please enter valid Valor",
        accountId: "Please select N conta/Moeda",
        exchangeRate: "Adicione a taxa de câmbio da conta",
        amountUsdValue: "Please enter valid Valor USD",
        deliveryTerm: "Please select Termo de entrega",
        currencyMissing: "Adicione a taxa de câmbio da conta",
        apiError: "Something went wrong"
    };

    const validationRules = {
        organizationId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.organizationId,
        },
        seqNumber: {
            validate: (value) => value && value.length >= 3,
            message: errors.seqNumber,
        },
        description: {
            validate: (value) => value && value.length >= 5,
            message: errors.description,
        },
        beneficiaryId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.beneficiaryId,
        },
        fundResource: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.fundResource,
        },
        natureId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.natureId,
        },
        registrationDate: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.registrationDate,
        },
        amount: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.amount,
        },
        accountId: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.accountId,
        },
        exchangeRate: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.exchangeRate,
        },
        amountUsdValue: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.amountUsdValue,
        },
        deliveryTerm: {
            validate: (value) => value !== undefined && value !== "",
            message: errors.deliveryTerm,
        },
    };

    useEffect(() => {
        fetchDropdownValues();
        setExistingData(existingFormData);
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal]);

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
        }
    }

    const [pdfFormat, setPdfFormat] = useState(""); // State to hold PDF format

    const handleCancel = () => {
        setExistingFormData(null);
        setModalState(false);
    }

    const handleAddBeneficiary = () => {
        setShowBeneficiaryModal(true);
    }

    const fetchDropdownValues = async () => {
        setLoading(true);
        try {
            let tempCurrency
            for (let i = 0; i < availableAccounts.length; i++) {
                if (availableAccounts[i].id === Number(accountId)) {
                    tempCurrency = availableAccounts[i].accountCurrency;
                    setCurrency(tempCurrency);
                }
            }
            let fromCurrency = tempCurrency;
            let toCurrency = "USD";
            if (tempCurrency === "JPY") {
                fromCurrency = "USD";
                toCurrency = "JPY";
            }
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/despesa/dropdown?fromCurrency=${fromCurrency}&toCurrency=${toCurrency}&organizationId=${organizationId}`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setNatures(responseData.data.natures);
                    setBeneficiaries(responseData.data.beneficiaries);
                    if (!existingFormData || !existingFormData.seqNumber) {
                        updateFormData('seqNumber', responseData.data.seqNumber);
                    }
                    if (tempCurrency === "JPY" && !responseData.data.exchangeRate) {
                        setErrorMessages({message: errors.currencyMissing})
                        return;
                    }
                    if (tempCurrency === "JPY" && responseData.data.exchangeRate) {
                        updateFormData('exchangeRate', responseData.data.exchangeRate)
                    } else {
                        updateFormData('exchangeRate', 1)
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    };

    const handleSubmit = async () => {
        for (let field in validationRules) {
            const {validate, message} = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({name: field, message: message});
                setErrorForField(field);
                return;
            }
        }

        setLoading(true);
        try {
            const requestOptions = {
                method: existingFormData != null && existingFormData.id !== undefined ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(formData)
            };
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/despesa`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseBody = await response.json();
                refreshData();
                setExistingFormData({id: responseBody.data.id});
                setExpenseConfirmModalState(true);
                setModalState(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    };

    const updateDescription = async () => {
        setLoading(true);
        try {
            const requestOptions = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify({
                    id: existingFormData.id,
                    description: formData.description,
                    beneficiaryId: formData.beneficiaryId,
                })
            };
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/despesa/description`;
            const response = await fetchWrapper(apiUrl, requestOptions);
            setLoading(false);
            if (response.ok) {
                const responseBody = await response.json();
                refreshData();
                setExistingFormData({id: responseBody.data.id});
                setExpenseConfirmModalState(true);
                setModalState(false);
            }
        } catch (error) {
            setLoading(false);
            if (error.body && error.body.responseInfo) {
                setErrorMessage(error.body.responseInfo.message);
                setShowErrorModal(true);
            } else {
                console.error("Error: Unable to handle ", error);
                setErrorMessage("Ocorreu um erro inesperado");
                setShowErrorModal(true);
            }
        }
    }

    return (
        <>
            {showErrorModal &&
                <ErrorModal
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMessage={errorMessage}
                />
            }
            {showModal && !showErrorModal ? (
                <>
                    <Loader show={loading}/>
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div
                                className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div
                                    className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Registrar Despesa</h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{overflowY: "auto", maxHeight: "70vh"}}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>

                                    <div className="flex space-x-6 items-center">
                                        {/* Orgão Field */}
                                        <div className="flex flex-col w-full">
                                            <label className="text-sm dark:text-white ml-1.5 font-medium">Orgão</label>
                                            <select
                                                className={`mt-1 h-12 w-full rounded-xl border bg-gray-100 text-gray-800 p-3 text-sm outline-none cursor-not-allowed dark:!border-white/10 dark:text-white`}
                                                id="organizationId"
                                                value={formData.organizationId}
                                                disabled
                                            >
                                                <option value="">Selecione órgão</option>
                                                {organizationData && organizationData.map((organization) => (
                                                    <option key={organization.id} value={organization.id}>
                                                        {organization.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">
                                        {/* Payment Date Field */}
                                        <div className="w-full">
                                            <div className="relative">
                                                <InputField
                                                    variant="auth"
                                                    label="N.Doc"
                                                    id="seqNumber"
                                                    type="text"
                                                    state={formErrorData.seqNumber === "error" ? "error" : ""}
                                                    value={formData.seqNumber}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        {/* Document Number Field */}
                                        <div className="w-1/2">
                                            <InputField
                                                variant="auth"
                                                label="Data de registro"
                                                placeholder="Data de registro"
                                                id="registrationDate"
                                                type="date"
                                                state={formErrorData.registrationDate === "error" ? "error" : ""}
                                                value={formData.registrationDate}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                                min={minDate}
                                                max={maxDate}
                                            />
                                        </div>
                                    </div>


                                    {/* Row 2: Full-Length Description Field */}
                                    <InputField
                                        variant="auth"
                                        extra="w-full mb-3"
                                        label="Descrição"
                                        placeholder="Insira os detalhes aqui"
                                        id="description"
                                        type="text"
                                        state={formErrorData.description === "error" ? "error" : ""}
                                        value={formData.description}
                                        onChange={handleInputChange}
                                    />

                                    {/* Row 3: Fatura Number and Beneficiary Dropdown on Same Line */}

                                    <div className="flex space-x-4 items-start">

                                        {/* Beneficiary Field */}
                                        <div className="w-full">
                                            <label
                                                className="text-sm  dark:text-white ml-1.5 font-medium">Beneficiário/empresa</label>
                                            <button className="dark:text-white ml-3" onClick={handleAddBeneficiary}>
                                                <IoPersonAdd/></button>
                                            {showBeneficiaryModal && (
                                                <BeneficiaryModal
                                                    showModal={showBeneficiaryModal}
                                                    setModalState={setShowBeneficiaryModal}
                                                    refreshData={fetchDropdownValues}
                                                />
                                            )}
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.beneficiary === "error" ? "border-red-500" : ""
                                                }`}
                                                id="beneficiaryId"
                                                value={formData.beneficiaryId}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Selecione Beneficiário</option>
                                                {beneficiaries && beneficiaries.map((beneficiary) => (
                                                    <option key={beneficiary.id} value={beneficiary.id}>
                                                        {beneficiary.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>


                                    {/* Row 4: Three Dropdowns (A, B, C) */}
                                    <div className="flex space-x-4">
                                        <div className="w-full mb-3">
                                            <label className="text-sm  dark:text-white ml-1.5 font-medium">Fonte de
                                                recursos</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.fundResource === "error" ? "border-red-500" : ""
                                                }`}
                                                id="fundResource"
                                                value={formData.fundResource}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            >
                                                <option value="">Selecione fonte de recursos</option>
                                                <option value="Recursos Próprios">Recursos Próprios</option>
                                                <option value="Recursos do Tesouro">Recursos do Tesouro</option>
                                            </select>
                                        </div>
                                        <div className="w-full mb-3">
                                            <label className="text-sm  dark:text-white ml-1.5 font-medium">Nat de
                                                despesa
                                            </label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.natureId === "error" ? "border-red-500" : ""
                                                }`}
                                                id="natureId"
                                                value={formData.natureId}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            >
                                                <option value="">Selecione nat de despesa</option>
                                                {natures && natures.map((nature) => (
                                                    <option key={nature.id} value={nature.id}>
                                                        {nature.category} - {nature.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Row 5: Register Date, Payment, and Value Amount Fields */}
                                    <div className="flex space-x-4 items-start">

                                        {/* Value Amount Field */}
                                        <div className="w-1/2">
                                            <InputField
                                                variant="auth"
                                                label="Valor"
                                                placeholder="Valor"
                                                id="amount"
                                                type="number"
                                                state={formErrorData.amount === "error" ? "error" : ""}
                                                value={formData.amount}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <label className="text-sm  dark:text-white ml-1.5 font-medium">N
                                                conta/Moeda</label>
                                            <select
                                                className={`mt-1 h-12 w-full rounded-xl border bg-gray-100 text-gray-800 p-3 text-sm outline-none cursor-not-allowed dark:!border-white/10`}
                                                id="accountId"
                                                value={formData.accountId}
                                                onChange={handleInputChange}
                                                disabled
                                            >
                                                <option value="">Selecione N conta/Moeda</option>
                                                {availableAccounts && availableAccounts.map((accounts) => (
                                                    <option key={accounts.id} value={accounts.id}>
                                                        {accounts.accountNumber ? accounts.accountNumber : accounts.accountName} - {accounts.accountCurrency}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex space-x-4 items-start">
                                        {/* First Dropdown Field */}


                                        {/* Text Field 1 */}
                                        <div className="w-1/3">
                                            <InputField
                                                variant="auth"
                                                label="Câmbio"
                                                placeholder="Câmbio"
                                                id="exchangeRate"
                                                type="number"
                                                state={formErrorData.exchangeRate === "error" ? "error" : ""}
                                                value={formData.exchangeRate}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>

                                        {/* Text Field 2 */}
                                        <div className="w-1/3">
                                            <InputField
                                                variant="auth"
                                                label={currency === 'EUR' ? 'Valor EUR' : 'Valor USD'}
                                                placeholder={currency === 'EUR' ? 'Valor EUR' : 'Valor USD'}
                                                id="amountUsdValue"
                                                type="number"
                                                state={formErrorData.amountUsdValue === "error" ? "error" : ""}
                                                value={formData.amountUsdValue}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>


                                        {/* Last Dropdown Field */}
                                        <div className="w-1/3">
                                            <label className="text-sm  dark:text-white ml-1.5 font-medium">Termo de
                                                entrega</label>
                                            <select
                                                className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none dark:!border-white/10  ${formErrorData.deliveryTerm === "error" ? "border-red-500" : ""
                                                }`}
                                                id="deliveryTerm"
                                                value={formData.deliveryTerm}
                                                onChange={handleInputChange}
                                                disabled={existingFormData && existingFormData.disabledView}
                                            >
                                                <option value="">Selecione termo de entrega</option>
                                                <option value="yes">Sim</option>
                                                <option value="no">não</option>
                                            </select>
                                        </div>

                                    </div>


                                </div>

                                {/* Modal Footer */}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>

                                    {
                                        (existingFormData && existingFormData.disabledView) ?
                                            (
                                                <button
                                                    onClick={updateDescription}
                                                    className={`linear mt-2 w-48 rounded-xl py-[12px] text-base font-medium text-white transition duration-200 ml-auto
                                                    bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"`}
                                                >
                                                    Descrição da atualização
                                                </button>
                                            ) :
                                            (
                                                <button
                                                    onClick={handleSubmit}
                                                    disabled={existingFormData && existingFormData.disabledView}
                                                    className={`linear mt-2 w-48 rounded-xl py-[12px] text-base font-medium text-white transition duration-200 ml-auto
                                                    ${existingFormData && existingFormData.disabledView ? "bg-brand-400 cursor-not-allowed" : "bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200"}`}
                                                >
                                                    Registrar
                                                </button>
                                            )
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Render GeneratePDF component if pdfFormat is set */}
                        {pdfFormat && <GeneratePDF format={pdfFormat}/>}
                    </div>


                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default ExpenseModal;
